export enum HomeType {
    CELLS_VIEW = 'cells view',
    FLOWS_VIEW = 'flows view'
}

export enum ClientTariff {
    NORMAL = 'Normal',
    ECONOMIC = 'Economic',
    SUPER_ECONOMIC = 'Super Economic',
    N = 'Normal',
    E = 'Economic',
    SE = 'Super Economic',
}



// WEBPACK FOOTER //
// ./src/app/entities/home/home.constants.ts